<template>
    <b-tabs>
        <b-tab title="Schnellsuche" active>
            <b-card bg-variant="light">
                <b-input-group>
                    <input
                        class="form-control"
                        v-model="filter.keywords"
                        :state="state"
                        @keyup.enter="simpleSearch"
                        tabindex="0"
                    />
                    <b-input-group-append>
                        <b-btn variant="outline-primary" @click="simpleSearch">Suche starten</b-btn>
                    </b-input-group-append>
                </b-input-group>
                <small class="form-text text-muted">
                    Hinweis: Neben den Original-Überschriften enthält die Datenbank eine redaktionell gepflegte Inhaltsangabe zu jedem Artikel. Die Artikeltexte sind als Bilddaten erfasst und nicht maschinell durchsuchbar.
                </small>
            </b-card>
        </b-tab>
        <b-tab title="Erweiterte Suche">
            <b-card bg-variant="light">
                <b-form-group
                    id="fieldset_topic"
                    label="Thema"
                    label-for="input_topic"
                >
                    <b-form-select id="input_topic" v-model="filter.topic" :state="state" :options="options.topics" />
                </b-form-group>
                <b-form-group
                    id="fieldset_title"
                    label="Titel des Artikels"
                    label-for="input_title"
                >
                    <b-form-input id="input_title" v-model="filter.title" :state="state"></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset_keywords"
                    label="Stichworte"
                    label-for="input_keywords"
                >
                    <b-form-input id="input_keywords" v-model="filter.keywords" :state="state"></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset_media"
                    label="Medien"
                    label-for="input_media"
                >
                    <b-form-checkbox-group id="input_media" v-model="filter.media" :state="state">
                        <template v-for="m in options.media">
                            <b-form-checkbox :value=m.value :key="m.value">{{ m.text }}</b-form-checkbox>
                        </template>
                    </b-form-checkbox-group>
                </b-form-group>
                <b-form-group
                    id="fieldset_externalmedia"
                    label="Fremdmedien"
                    label-for="input_externalmedia"
                >
                    <b-form-checkbox-group id="input_externalmedia" v-model="filter.externalMedia" :state="state">
                        <template v-for="m in options.externalMedia">
                            <b-form-checkbox :value=m.value :key="m.value">{{ m.text }}</b-form-checkbox>
                        </template>
                    </b-form-checkbox-group>
                </b-form-group>
                <b-form-group
                    id="fieldset_type"
                    label="Textsorte"
                    label-for="input_type"
                >
                    <b-form-select id="input_type" v-model="filter.textType" :options="options.textType" :state="state" />
                    <b-form-checkbox value="1" v-model="filter.frontPage" :state="state">Auf der Titelseite</b-form-checkbox>
                </b-form-group>
                <b-form-group
                    id="fieldset_type"
                    label="Platzierung"
                    label-for="input_placement"
                >
                    <b-form-select id="input_placement" v-model="filter.placement" :options="options.placement" />
                    <b-form-checkbox value="1" v-model="filter.illustration">Mit Bild</b-form-checkbox>
                </b-form-group>
                <b-form-group
                    id="fieldset_dataindex"
                    label="Datensatznummer"
                    label-for="input_dataindex"
                >
                    <b-form-input id="input_dataindex" v-model="filter.dataIndex" :state="state"></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset_date"
                    label="Datum"
                    label-for="input_date_group"
                >
                    <div class="form-group row" id="fieldset_date_group">
                        <label class="col-sm-2 col-form-label" for="input_date_from">von</label>
                        <div class="col-sm-4">
                            <input class="form-control" id="input_date_from" v-model="filter.dateRange.begin" :state="state" />
                        </div>
                        <label class="col-sm-2 col-form-label" for="input_date_till">bis</label>
                        <div class="col-sm-4">
                            <input class="form-control" id="input_date_till" v-model="filter.dateRange.end" :state="state" />
                        </div>
                    </div>
                </b-form-group>
                <b-form-group>
                    <b-button type="submit" variant="outline-primary" @click="filteredSearch">Suche starten</b-button>
                    <b-button type="reset" variant="outline-danger" @click="resetSearchFilter">Zurücksetzen</b-button>
                </b-form-group>
            </b-card>
        </b-tab>
    </b-tabs>
</template>

<script>
import store from '@/store'
import Mapping from '@/mapping'

let SearchFilterModel = {
    topic: null,
    title: null,
    keywords: null,
    placement: null,
    textType: null,
    media: [],
    externalMedia: [],
    frontPage: null,
    illustration: null,
    dataIndex: null,
    dateRange: {
        begin: '02.12.1966',
        end: '31.12.1968'
    }
}

export default {
    name: 'SearchForm',
    data () {
        return {
            state: null,
            filter: Object.assign({}, SearchFilterModel),
            options: {
                topics: [
                    {
                    value: null,
                    text: 'Bitte auswählen'
                    },
                    ...Mapping.topic.getValues()
                ],
                textType: [
                    {
                    value: null,
                    text: 'Bitte auswählen'
                    },
                    ...Mapping.type.getValues()
                ],
                placement: [
                    {
                    value: null,
                    text: 'Bitte auswählen'
                    },
                    ...Mapping.placement.getValues()
                ],
                media: Mapping.media.getValues(val => {
                    return !val.hasOwnProperty('external') || val.external == false
                }),
                externalMedia: Mapping.media.getValues(val => {
                    return val.hasOwnProperty('external') && val.external == true
                }),
            }
        }
    },
    methods: {
        simpleSearch(event) {
            let filter = {
                topic: null,
                title: null,
                keywords: null,
                placement: null,
                textType: null,
                media: [],
                frontPage: null,
                illustration: null,
                dataIndex: null,
                dateRange: {
                    begin: '02.12.1966',
                    end: '31.12.1968'
                }
            }

            filter.keywords = '' + this.filter.keywords
            store.dispatch('updateSearch', filter)
        },
        filteredSearch(event) {
            console.log(this.filter)
            store.dispatch('updateSearch', this.filter)
        },
        resetSearchFilter(event) {
            this.filter = {
                topic: null,
                title: null,
                keywords: null,
                placement: null,
                textType: null,
                media: [],
                frontPage: null,
                illustration: null,
                dataIndex: null,
                dateRange: {
                    begin: '02.12.1966',
                    end: '31.12.1968'
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SearchForm.vue